export const securityKey = {
    /** Dashboard */
      DASHBOARD: "DashBoard",

    //   HR Management
      HRMANAGEMENT: "Hr Management",
            CANDIDATELIST: "Candidate List",
                    IMPORTCANDIDATE:"Import Candidate",
                    EXPORTCANDIDATE:"Export Candidate",
                    EDITCANDIDATE:"Edit Candidate",
                    DELETECANDIDATE:"Delete Candidate",

            FOLLOWUPCANDIDATE: "Follow-Up Candidates",
            SCHEDULEINTERVIEW: "Schedule Interview",


      

    //   Manage Questions
      MANAGEQUESTIONS:"Manage Questions",
            QUESTIONSLIST:"Questions List",
                    ADDQUESTIONS :"Add Question",
                    EDITQUESTIONS :"Edit Question",
                    DELETEQUESTIONS: "Delete Question",


    //   Configure Skills
      CONFIGURESKILLS:"Configure Skills",
            SKILLCATEGORY:"Skill Category",
                    ADDSKILL :"Add Skill",
                    EDITSKILL :"Edit Skill",
                    DELETESKILL: "Delete Skill",
                    
            MAINSKILL:"Main Skill",
                    ADDMAINSKILL :"Add Main Skill",
                    EDITMAINSKILL :"Edit Main Skill",
                    DELETEMAINSKILL: "Delete Main Skill",
                    ADDSUBSKILL:"Add Sub Skill",
                    EDITSUBSKILL:"Edit Sub Skill",
                    DELETESUBSKILL:"Delete Sub Skill",



    //   Reports
      REPORTS: "Reports",
            CANDIDATEREPORT: "Candidate Report",
                    EXPORTCANDIDATEREPORT: "Export Candidate Report",

            JOBREPORT: "Job Report",
                    EXPORTJOBREPORT: "Export Job Report",

            ACTIVITYLOGREPORT: "Activity Log Report",
                    ACTIVITYLOGEXPORT:"Activity Log Export",



    // System Configuration
      SYSTEMCONFIGURATION:"System Configuration",
            INTERVIEWROUND: "Interview Round",
                    ADDINTERVIEWROUND: "Add Interview Round",
                    EDITINTERVIEWROUND: "Edit Interview Round",
                    DELETEINTERVIEWROUND: "Delete Interview Round",

            INTERVIEWTYPE: "Interview Type",
                    ADDINTERVIEWTYPE: "Add Interview Type",
                    EDITINTERVIEWTYPE: "Edit Interview Type",
                    DELETEINTERVIEWTYPE: "Delete Interview Type",

            JOBPOSITION: "Job Position",
                    ADDJOBPOSITION: "Add Job Position",
                    EDITJOBPOSITION: "Edit Job Position",
                    DELETEJOBPOSITION: "Delete Job Position",

            REJECTEDREASON: "Rejected Reason",
                    ADDREJECTEDREASON: "Add Rejected Reason",
                    EDITREJECTEDREASON: "Edit Rejected Reason",

            FOLLOWUPREASON: "Followup Reason",
                    ADDFOLLOWUPREASON: "Add Followup Reason",
                    EDITFOLLOWUPREASON: "Edit Followup Reason",
                    DELETEFOLLOWUPREASON:"Delete Followup Reason",

            SECURITY: "Security",
                    ADDSECURITYROLE: "Add Security Role",
                    EDITSECURITYROLE: "Edit Security Role",
                    DELETESECURITYROLE: "Delete Security Role",
                    ASSIGNUSER: "Assign User",
                        ADDASSIGNUSERS: "Add Assign Users",
                        DELETEASSIGNUSERS: "Delete Assign Users",

                    PERMISSION: "Permission",
                        SAVEPERMISSIONS: "Save Permission",
                
    //   Management
      MANAGEMENT : "ManageMent",
            USERMANAGEMENT: "User Management",
                    ADDUSER: "Add User",
                    EDITUSER: "Edit User",
            
            EMAILTEMPLATE:"Email Template",
                    ADDEMAILTEMPLATE: "Add Email Template",
                    EDITEMAILTEMPLATE: "Edit Email Template",

            SYSTEMACTION: "System Action",
                    ADDSYSTEMACTION: "Add System Action",
                    EDITSYSTEMACTION: "Edit System Action",
                    DELETESYATEMACTION:"Delete System Action",
    
	   STATUS:"Status",
                    EDITSTATUS:"Edit Status",

            MANAGECHANNEL: "Manage Channel",
                    ADDMANAGECHANNEL: "Add Manage Channel",
                    EDITMANAGECHANNEL: "Edit Manage Channel",
                    DELETEMANAGECHANNEL: "Delete Manage Channel",
                
            MANAGESOURCE: "Manage Source",
                    ADDMANAGESOURCE: "Add Manage Source",
                    EDITMANAGESOURCE: "Edit Manage Source",
                    DELETEMANAGESOURCE: "Delete Manage Source",

            DEPARTMENT: "Department",
                    ADDDEPARTMENT: "Add Department",
                    EDITDEPARTMENT: "Edit Department",
                    DELETEDEPARTMENT: "Delete Department",
            
        ADDCANDIDATE: "Add Candidate",

        RECYCLEBIN: "Recycle Bin"
};
